<script setup lang="ts">
  import { container } from './NotFound.css';
  import somethingWrong from '@tundr/theme-assets/illustrations/something-wrong.png';
  import {
    EmptyState,
    EmptyStateSurface,
    Link,
    LinkVariant,
  } from '@tundr/ds-components';
</script>

<template>
  <div :class="container">
    <EmptyState
      :surface="EmptyStateSurface.NONE"
      :svg-image="somethingWrong"
      :svg-width="200"
      :svg-height="200"
      title="404 - Pagina non trovata!"
      title-as="h1"
    >
      <template #description>
        <Link to="/" :variant="LinkVariant.Secondary">Torna alla Home</Link>
      </template>
    </EmptyState>
  </div>
</template>
